import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
    static targets = ["modal"]

    close(event) {
        if(!event.currentTarget.classList.contains("close-icon") && event.target.closest("[data-modal-target='modal']")) return

        this.element.classList.add("close-modal")
        setTimeout(function () { this.element.remove() }.bind(this), 500 )
    }
}
